const generateRandomIntegerInRange = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

export default generateRandomIntegerInRange;
